import { render } from "./OfflineMarKetingPage.vue?vue&type=template&id=fa395b94"
import script from "./OfflineMarKetingPage.vue?vue&type=script&lang=js"
export * from "./OfflineMarKetingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__